import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterFieldsData: [],
}

const SuperviosrFilterSlice = createSlice({
    name: 'filterFields',
    initialState,
    reducers: {
        handleFilterData(state, action) {
            state.filterFieldsData = action.payload;
        },
    }
})

export const {
    handleFilterData,
} = SuperviosrFilterSlice?.actions
export default SuperviosrFilterSlice?.reducer